import React from "react";
import { memo } from "react";
import { Grid, TextField } from "@mui/material";
import { mascararCelular, mascararTelefone } from "./fichaFormato";
import { inputSx } from "./fichaEstilos";

// ── Sub-componente: bloco de telefone + celular ───────────────────────────────

function BlocoTelefoneImpl({ prefixTel, prefixCel, form, setField, ro, ehAprovador = false, labelTel = "Telefone" }) {
  const vz = (f) => ehAprovador && !(form[f] ?? "");
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label={labelTel}
          size="small"
          fullWidth
          value={form[prefixTel] ?? ""}
          placeholder="(00) 0000-0000"
          onChange={(e) => !ro && setField(prefixTel, mascararTelefone(e.target.value))}
          slotProps={{ input: { readOnly: ro }, htmlInput: { maxLength: 15 } }}
          sx={inputSx(ro, vz(prefixTel))}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Celular"
          size="small"
          fullWidth
          value={form[prefixCel] ?? ""}
          placeholder="(00) 00000-0000"
          onChange={(e) => !ro && setField(prefixCel, mascararCelular(e.target.value))}
          slotProps={{ input: { readOnly: ro }, htmlInput: { maxLength: 15 } }}
          sx={inputSx(ro, vz(prefixCel))}
        />
      </Grid>
    </Grid>
  );
}

function mesmosCamposTelefone(prev, next) {
  return (
    prev.prefixTel === next.prefixTel &&
    prev.prefixCel === next.prefixCel &&
    prev.setField === next.setField &&
    prev.ro === next.ro &&
    prev.ehAprovador === next.ehAprovador &&
    prev.labelTel === next.labelTel &&
    prev.form[prev.prefixTel] === next.form[next.prefixTel] &&
    prev.form[prev.prefixCel] === next.form[next.prefixCel]
  );
}

export const BlocoTelefone = memo(BlocoTelefoneImpl, mesmosCamposTelefone);
